import { all } from 'redux-saga/effects';
import { login, logout, resetPassword, confirmPassword, loginReintegro, logoutReintegro, changePassword, getUserModules, authenticateToken } from "./sagaLogin";
import {
    getSuppliers, getCoverages, getZones, getCategories, getOffices, saveInfoStep, saveInfoStepRefund, updateProduct,
    uploadFile, getSearchCoverages, getRateDetail, uploadImage, editOfficesRate, saveReintegro, getReintegros, getReintegro, getRefundData, getRefundDataImages, editReintegro, uploadImageReintegro, getCommentRefund, createCommentRefund, getHashExportReintegrosList, checkExportReintegrosList, getAllManagers
} from "./saga";
import { getBillingById, getBillingsList, editBillingById, getHashExportBillingList, checkExportBillingList } from "./sagaBillings";
import { getRateByIdSearchCopies, getRatesFiltered, deleteUpdateMarketRates, getRatesList, editBatchUpdateRates, editUpdateMarketRates, getBatchUpdateRates, getRateById, deleteRateRelationsSaga, editRateById, getRateDetailJson, uploadRateDetailFile, uploadRateDetailJson, getDuplicateRate, downloadRateValues, checkExportRates, createRateRelationsSaga, getHashExportRatesList, checkExportRatesList, updateExportRatesList } from "./sagaRates";
import { getCoverage, getCoveragesList, addCoverage, removeCoverage, editCoverage, getRequirementsList, addRequirementCoverage, editRequirementCoverage, deleteRequirementCoverage, addRequirementToCoverage } from "./sagaCoveragesAbm";
import { getCategory, getCategoriesList, addCategory, removeCategory, editCategory, getProductsLine, getProductLine, addProductLine, removeProductLine, editProductLine } from "./sagaCategoriesAbm";
import { getGroup, getGroupsList, addGroup, removeGroup, editGroup } from "./sagaGroupsAbm";
import { getUser, getUsersList, addUser, removeUser, editUser, getPermission, addVisibilityDashboard, getHashExportUsersList, checkExportUsersList, updateExportUsersList } from "./sagaUsersAbm";
import { getCountry, getCountriesList, addCountry, removeCountry, editCountry } from "./sagaCountriesAbm";
import { getCountryCode, getCountryCodeList, addCountryCode, removeCountryCode, editCountryCode } from "./sagaCountrycodesAbm";
import { getMunicipio, getMunicipiosList } from "./sagaMunicipiosAbm";
import { getSupplier, getSuppliersList, addSupplier, removeSupplier, editSupplier } from "./sagaSuppliersAbm";
import { getZone, getZonesList, addZone, removeZone, editZone } from "./sagaZonesAbm";
import {
    getOffice, getOfficesList, getOfficeParent, addOffice, removeOffice, duplicateOffice, addDuplicateOffice, editOffice, getSperta, getKaring, getPayment, getPaymentHistory,
    getAditionalOffices, addAditionalOffice, removeAditionalOffice, editAditionalOffice, getHashExportOfficesList, checkExportOfficesList, updateExportOfficesList, getOfficeListLimited, getCanales, getCanal, addCanal, removeCanal, editCanal, removeOfficeProducts
} from "./sagaOfficesAbm";
//import { getOffice, getOfficesList, getOfficeParent, addOffice, removeOffice, editOffice, getSperta, getPayment, getPaymentHistory,
//    getAditionalOffices, addAditionalOffice, removeAditionalOffice, editAditionalOffice} from "./sagaOfficesAbm";

import { getValidListDuplicateCodeProduct, getProductsList, getProductsListLongName, getProductsListReducida, getSortedProductsList, removeProduct, sortProductsList, getTypologiesList, addTypologyProducts, editTypologyProducts, deleteTypologyProducts, getFilterRateList, sagaSetProductCode } from "./sagaProductsAbm";
import { getPromotionsList, editPromotion, addPromotion, removePromotion, getPromotion, addProductOffices, deleteProductOffices, getProductOffices, editProductOffices, deletePromotionProductOffices, getHashExportPromotionsList, checkExportPromotionsList, getOfficesInPromotionProduct, getValidateOfficesInPromotionProduct, getPromotionByIdWatcher, editPromotionsBatchWatcher } from "./sagaPromotionsAbm";

import { getTag, getTagsList, addTag, removeTag, editTag, postOfficeMassiveTags } from "./sagaTagsAbm";
import { getBusinessUnit, getBusinessUnitsList, addBusinessUnit, removeBusinessUnit, editBusinessUnit } from "./sagaBusinessUnitsAbm";
import { getCurrency, getCurrenciesList, addCurrency, removeCurrency, editCurrency } from "./sagaCurrenciesAbm";
import { getReservation, getReservationsList, getReservationsListReduced, getFilteredReservationsList, getExportReservationsList, addReservation, removeReservation, editReservation, editEmailSendReservation } from "./sagaReservationsAbm";
import { deleteResumeConciliationById, createResumeConciliationById, editResumeConciliationById, getResumeConciliationById, getResumeConciliationsList, getConciliation, getConciliationsList, getFilteredConciliation, getExportConciliation, uploadFileConciliations, getManualConciliation, revertConciliation, getCommentConciliation, createCommentConciliation, getTransactionSummary, getTransactionTypeNameListSent, addTransactionTypeName, editTransactionTypeName, deleteTransactionTypeName, getTransactionItemBankNameListSent, addTransactionItemName, editTransactionItemName, getTransactionItemSpertaNameListSent, deleteTransactionItemName, uploadFileConciliationBilling, checkExportCobranzasExtractSaga, checkExportCobranzasConciliacionList } from "./sagaConciliationsAbm";
import {
    getVoucher, getVouchersList, getVouchersListReduced, addVoucher, removeVoucher, editVoucher, cancelAllVouchers, changeStatusVouchers, printVoucher, printReservationMultivoucher,
    sendTermsAndConditions, sendMailCCGG, sendMailMultivoucher, getHashExportVouchersList, checkExportVouchersList, updateExportVouchersList, resendEmailInvoice, printReservationInvoice, getCommentVoucher, createCommentVoucher
} from "./sagaVouchersAbm";
import { getPassenger, getPassengersList, addPassenger, removePassenger, editPassenger, getPassengerByDoc } from "./sagaPassengersAbm";
import { getProductSperta, getProductsSpertaList, addProductSperta, removeProductSperta, editProductSperta } from "./sagaProductsSpertaAbm";
import { getBlacklist, getPassengerBlacklist, addPassengerBlacklist, editPassengerBlacklist, removePassengerBlacklist } from "./sagaBlacklist";
import { addFacturacion, getHashExportFacturacionList, checkExportFacturacionList, getInvoicesList, getInvoice } from "./sagaFacturacion";
import { getPaymentMethods, getPaymentDetail } from "./sagaPaymentDetailAbm"
import { landings, banners, footers, headers, homeComments, homeCoverages, homeDifferentialServices, homeWhyChooseUs, homeProductNecessity, homeLandingCities, notifications } from './sagaBackoffice';
import { getDiscount, getDiscountsList, addDiscount, editDiscount, removeDiscount, getCategoryNameListSent, addCategoryName, editCategoryName, getDiscountsHistoryList, getDiscountsHistory, getHashExportHistoryCouponsList, checkExportHistoryCouponsList, updateExportHistoryCouponsList, getHashExportDiscountsList, checkExportDiscountsList, updateExportDiscountsList } from "./sagaDiscounts"
import { getAlertSaga, getAlertsList, createAlertSaga, editAlertSaga, deleteAlertSaga } from "./sagaAlerts"
import { addAncillary, editAncillary, getAncillariesList, getAncillary, removeAncillary } from './sagaAncillaries';
import { addAncillaryMaster, editAncillaryMaster, getAncillariesMasterList, getAncillaryMaster, removeAncillaryMaster } from './sagaAncillariesMaster';
import sagaStageRangeAbm from './sagaStageRangeAbm';
import sagaAgeGroup from './sagaAgeGroup';
import sagaExecutiveGoal from './sagaExecutiveGoal';
import sagaAgencyIncentive from './sagaAgencyIncentive';
import sagaFinancingDiscount from './sagaFinancingDiscount';
import sagaBackendScale from './sagaBackendScale';

export default function* rootSaga() {
    yield all([
        login(),
        logout(),
        getAllManagers(),
        resetPassword(),
        confirmPassword(),
        loginReintegro(),
        changePassword(),
        getUserModules(),
        authenticateToken(),
        getCountriesList(),
        addCountry(),
        getCountry(),
        removeCountry(),
        editCountry(),
        getCountryCode(),
        addCountryCode(),
        getCountryCodeList(),
        removeCountryCode(),
        editCountryCode(),
        getMunicipio(),
        getMunicipiosList(),
        getSupplier(),
        getSuppliers(),
        getSuppliersList(),
        addSupplier(),
        removeSupplier(),
        editSupplier(),
        getCategories(),
        getZones(),
        getCoverage(),
        getCoveragesList(),
        getCoverages(),
        addCoverage(),
        removeCoverage(),
        editCoverage(),
        getRequirementsList(),
        addRequirementCoverage(),
        editRequirementCoverage(),
        deleteRequirementCoverage(),
        addRequirementToCoverage(),
        getSearchCoverages(),
        getOffices(),
        saveInfoStep(),
        saveInfoStepRefund(),
        updateProduct(),
        uploadFile(),
        uploadFileConciliations(),
        getManualConciliation(),
        revertConciliation(),
        getCommentConciliation(),
        createCommentConciliation(),
        uploadFileConciliationBilling(),
        checkExportCobranzasConciliacionList(),
        checkExportCobranzasExtractSaga(),
        getTransactionSummary(),
        getTransactionTypeNameListSent(),
        addTransactionTypeName(),
        editTransactionTypeName(),
        deleteTransactionTypeName(),
        deleteTransactionItemName(),
        getTransactionItemBankNameListSent(),
        getTransactionItemSpertaNameListSent(),
        addTransactionItemName(),
        editTransactionItemName(),
        uploadImage(),
        saveReintegro(),
        getReintegros(),
        getReintegro(),
        getRefundData(),
        getRefundDataImages(),
        editReintegro(),
        uploadImageReintegro(),
        getCommentRefund(),
        createCommentRefund(),
        getHashExportReintegrosList(),
        checkExportReintegrosList(),
        getBillingById(),
        getBillingsList(),
        editBillingById(),
        getHashExportBillingList(),
        checkExportBillingList(),
        editOfficesRate(),
        editBatchUpdateRates(),
        editUpdateMarketRates(),
        deleteUpdateMarketRates(),
        deleteRateRelationsSaga(),
        getHashExportOfficesList(),
        checkExportOfficesList(),
        updateExportOfficesList(),
        addZone(),
        editZone(),
        removeZone(),
        getZonesList(),
        getExportConciliation(),
        getZone(),
        getProductsList(),
        getProductsListLongName(),
        getFilteredConciliation(),
        getProductsListReducida(),
        removeProduct(),
        getSortedProductsList(),
        sortProductsList(),
        getCategory(),
        getCategoriesList(),
        addCategory(),
        removeCategory(),
        editCategory(),
        getGroup(),
        getGroupsList(),
        addGroup(),
        removeGroup(),
        editGroup(),
        getUser(),
        getUsersList(),
        addUser(),
        removeUser(),
        editUser(),
        getPermission(),
        addVisibilityDashboard(),
        getOffice(),
        getOfficesList(),
        getOfficeListLimited(),
        getProductsLine(),
        getProductLine(),
        addProductLine(),
        removeProductLine(),
        editProductLine(),
        getTypologiesList(),
        addTypologyProducts(),
        editTypologyProducts(),
        deleteTypologyProducts(),
        getCanales(),
        getCanal(),
        addCanal(),
        removeCanal(),
        editCanal(),
        removeOfficeProducts(),
        getOfficeParent(),
        addOffice(),
        removeOffice(),
        addDuplicateOffice(),
        duplicateOffice(),
        editOffice(),
        getAditionalOffices(),
        addAditionalOffice(),
        editAditionalOffice(),
        removeAditionalOffice(),
        getSperta(),
        getKaring(),
        getPayment(),
        getPaymentHistory(),
        getPromotionsList(),
        addPromotion(),
        removePromotion(),
        editPromotion(),
        getPromotion(),
        addProductOffices(),
        deleteProductOffices(),
        getProductOffices(),
        editProductOffices(),
        deletePromotionProductOffices(),
        getOfficesInPromotionProduct(),
        getValidateOfficesInPromotionProduct(),
        getPromotionByIdWatcher(),
        editPromotionsBatchWatcher(),
        getHashExportPromotionsList(),
        checkExportPromotionsList(),
        getRatesFiltered(),
        getRatesList(),
        getBatchUpdateRates(),
        getRateById(),
        getRateByIdSearchCopies(),
        editRateById(),
        getRateDetail(),
        getRateDetailJson(),
        uploadRateDetailFile(),
        uploadRateDetailJson(),
        getDuplicateRate(),
        downloadRateValues(),
        checkExportRates(),
        getTag(),
        getTagsList(),
        addTag(),
        removeTag(),
        editTag(),
        postOfficeMassiveTags(),
        getBusinessUnit(),
        getBusinessUnitsList(),
        addBusinessUnit(),
        removeBusinessUnit(),
        editBusinessUnit(),
        getCurrency(),
        getCurrenciesList(),
        addCurrency(),
        removeCurrency(),
        editCurrency(),
        getConciliation(),
        getConciliationsList(),
        getResumeConciliationsList(),
        getResumeConciliationById(),
        editResumeConciliationById(),
        createResumeConciliationById(),
        deleteResumeConciliationById(),
        getReservation(),
        getReservationsList(),
        getReservationsListReduced(),
        getFilteredReservationsList(),
        getExportReservationsList(),
        addReservation(),
        removeReservation(),
        editReservation(),
        editEmailSendReservation(),
        getVoucher(),
        getVouchersList(),
        getVouchersListReduced(),
        getHashExportVouchersList(),
        checkExportVouchersList(),
        updateExportVouchersList(),
        addVoucher(),
        removeVoucher(),
        editVoucher(),
        cancelAllVouchers(),
        changeStatusVouchers(),
        printVoucher(),
        printReservationMultivoucher(),
        sendTermsAndConditions(),
        sendMailCCGG(),
        sendMailMultivoucher(),
        getCommentVoucher(),
        createCommentVoucher(),
        resendEmailInvoice(),
        printReservationInvoice(),
        getPassenger(),
        getPassengerByDoc(),
        getPassengersList(),
        addPassenger(),
        removePassenger(),
        editPassenger(),
        getProductSperta(),
        getProductsSpertaList(),
        addProductSperta(),
        removeProductSperta(),
        editProductSperta(),
        getValidListDuplicateCodeProduct(),
        addFacturacion(),
        getHashExportFacturacionList(),
        checkExportFacturacionList(),
        getInvoicesList(),
        getInvoice(),
        getBlacklist(),
        getPassengerBlacklist(),
        addPassengerBlacklist(),
        editPassengerBlacklist(),
        removePassengerBlacklist(),
        getPaymentDetail(),
        getPaymentMethods(),
        getDiscount(),
        getDiscountsList(),
        addDiscount(),
        editDiscount(),
        removeDiscount(),
        getCategoryNameListSent(),
        addCategoryName(),
        editCategoryName(),
        getDiscountsHistoryList(),
        getDiscountsHistory(),
        checkExportDiscountsList(),
        updateExportDiscountsList(),
        getHashExportDiscountsList(),
        getHashExportHistoryCouponsList(),
        checkExportHistoryCouponsList(),
        updateExportHistoryCouponsList(),
        landings(),
        banners(),
        headers(),
        footers(),
        homeComments(),
        homeCoverages(),
        homeDifferentialServices(),
        homeWhyChooseUs(),
        homeProductNecessity(),
        homeLandingCities(),
        notifications(),
        getAlertSaga(),
        getAlertsList(),
        editAlertSaga(),
        createAlertSaga(),
        deleteAlertSaga(),
        getFilterRateList(),
        createRateRelationsSaga(),
        sagaSetProductCode(),
        getHashExportUsersList(),
        checkExportUsersList(),
        updateExportUsersList(),
        getHashExportRatesList(),
        checkExportRatesList(),
        updateExportRatesList(),
        getAncillary(),
        getAncillariesList(),
        addAncillary(),
        editAncillary(),
        removeAncillary(),
        getAncillaryMaster(),
        getAncillariesMasterList(),
        addAncillaryMaster(),
        editAncillaryMaster(),
        removeAncillaryMaster(),
        sagaStageRangeAbm(),
        sagaAgeGroup(),
        sagaExecutiveGoal(),
        sagaAgencyIncentive(),
        sagaFinancingDiscount(),
        sagaBackendScale()
    ])
}
